import { FilteredReferentialsIds } from '@scenario/models/filtered-referentials-ids.model';
import { FilteredReferentialsGateway } from '@scenario/gateways/filtered-referentials.gateway';
import { environment } from '../../../../../environments/environment';
import { formatPostHeaders } from '@configurations/api-configuration';

export class ApiFilteredReferentialsGateway implements FilteredReferentialsGateway {
  private readonly filteredReferentialsApi = `${environment.backend_url}/api/v1/dynamicFilter`;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async retrieveAllIds(filters: FilteredReferentialsIds): Promise<FilteredReferentialsIds> {
    try {
      const response = await fetch(`${this.filteredReferentialsApi}`, await formatPostHeaders(filters));
      return await response.json();
    } catch (error) {
      throw new Error('Error retrieving filtered referentials :' + error);
    }
  }
}




